import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Gutter } from '@gaiads/telia-react-component-library';
import { CustomPaginator, AssetsList, PageChangeInfo, AssetsListTranslations } from '@cdaas/reusable-components-daas';
import { AssetResponseWithAutoOpen } from '@cdaas/reusable-components-daas/dist/src/asset-api-types/api-types';
import { PageInfo, OrganizationAssetResponse } from '@cdaas/api-clients/dist/asset-user-openapi';

import './OrganizationAssetsTable.css';

interface OrganizationAssetsTableProps {
  loading?: boolean;
  assets: AssetResponseWithAutoOpen[];
  pageInfo?: PageInfo;
  onPageChange: (pageChangeInfo: PageChangeInfo<AssetResponseWithAutoOpen>) => void;
}

const OrganizationAssetsTable: FunctionComponent<OrganizationAssetsTableProps> = ({ loading, assets, pageInfo, onPageChange }) => {
  const history = useHistory();
  const { t } = useTranslation('assets');

  const handleOpenAssetButton = (id: OrganizationAssetResponse['id']) => {
    history.push(`/organizationassets/${id}`);
  };

  const translations: AssetsListTranslations = {
    noDataText: t('OrganizationAssets.noDataText'),
    name: t('OrganizationAssets.name'),
    user: t('OrganizationAssets.user'),
    tableOpenRowButton: t('OrganizationAssets.tableOpenRowButton'),
    errorText: t('OrganizationAssets.apiError'),
    companyDevice: t('companyDevice'),
    inactiveUser: t('inactiveUser'),
  };

  return (
    <>
      {/* TODO: Implement search when backend supports it
      <Flex centeredVertically spaceBetween>
        <Input
          showCustomLabel
          className={'organization-assets-search-input'}
          label={''}
          placeholder={t('OrganizationAssets.searchAssetsPlaceholder')}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          iconName={'search'}
        />
      </Flex> */}

      <Gutter />
      <AssetsList loading={loading} assets={assets} buttonClickCallback={asset => handleOpenAssetButton(asset.id)} translations={translations} />
      {pageInfo?.total_items ? (
        <CustomPaginator
          activatePageInfoObject={pageInfo}
          onPageChange={onPageChange}
          paginatorStyleProps={{
            paginationProps: {},
            pageSelectorProps: { centered: true },
          }}
        />
      ) : null}
    </>
  );
};

export default OrganizationAssetsTable;
